<template>
  <div>
    <section class="ContentAligher SectionSpacing">
      <div class="row">
        <div class="col-md-6">
          <ul id="ImageGal">
            <template  v-for="item in data.portfolio_images" >
            <li :data-thumb="base_path + item">
              <img :src="base_path + item" class="responsive">
            </li>
            </template>
          </ul>
        </div>
        <div class="col-md-6">
            <h1 class="bold">{{ data.project_location_city}}</h1>
            <h4 class="bold">{{ data.project_location_address}}</h4>

            <table id="liftSpecTable">
              <tr v-for="item in data.project_specs_required">
                <td><span :class="'ListIcon LI_'+s_titles[item.title] "></span></td>
                <td><p class="bold">{{ s_titles[item.title] }}</p></td>
                <td><p>{{ item.desc }}</p></td>
              </tr>
              <tr v-for="item in data.project_specs_optianal">
                <td></td>
                <td><p class="bold">{{ item.title }}</p></td>
                <td><p>{{ item.desc }}</p></td>
              </tr>
            </table>
        </div>
      </div>
    </section>

    <div id="ProtfolioNPBar" class="ContentAligher">
      <div class="row">
        <div class="col-md-6">
          <a :href="data.previous_id"><img :src="require('@/assets/images/left.png')"> Previous Project</a>
        </div>
        <div class="col-md-6 T_alignRight">
          <a :href="data.next_id" class="T_alignRight">Next Project <img :src="require('@/assets/images/right.png')"> </a>
        </div>
      </div>
    </div>



    <section class="ContentAligher SectionSpacing">
      <div class="row">
        <div class="col-md-12">
          <h1 class="bold">Similar Projects</h1>

          <div class="row">
              <div class="col-md-4 col-sm-6" v-for="(data, key, index) in random" :key="key">
                  <div class="padding-tb-16 relative">
                    <div class="TextOverlay">
                      <h3 class="bold">{{ data.project_location_city }}</h3>
                      <p  class="bold">{{ data.project_title }}</p>
                      <a :href="data.id">View</a>
                    </div>
                    <img :src="base_path + data.portfolio_images[0]" class="responsive" @load="loaded" />
                  </div>
              </div>
          </div>

        </div>
      </div>
    </section>

    <rwv-general-form></rwv-general-form>
  </div>
</template> 
<script>

//import RwvSubscribe from '@/components/Subscribe'
import * as $ from 'jquery'
import Vue from 'vue';
import VeeValidate from 'vee-validate';

import axios from 'axios'
import { API_BASE_URL } from '../config'
import { BASE_URL } from '../config'

Vue.use(VeeValidate);


import '@/assets/js/easyResponsiveTabs'
import '@/assets/js/lightslider'
import RwvGeneralForm from '@/components/GeneralForm';


export default{
  name: 'PortfolioDetailed',
  components: {
    RwvGeneralForm
  },
  data: function() {
    return {
     base_path: BASE_URL,
     random: null,
     s_titles: ['Ceiling', 'Panels', 'Base', 'Flooring', 'Lighting'],
     data: {
              "id": 14,
              "portfolio_images": [],
              "created_at": "",
              "updated_at": "",
              "project_title": "",
              "project_location_city": "",
              "project_location_address": "",
              "project_system": "",
              "project_specs_required": [
                {
                "title": "",
                "desc": ""
                }
              ],
              "project_specs_optianal": [
                {
                "title": "",
                "desc": ""
                }
              ],
              "previous_id": null,
              "next_id": null
            }
    }
  },
  mounted() {

    axios.get(API_BASE_URL + 'portfolio/' + this.$route.params.id )
    .then(response => {this.data = response.data}).finally(function(){
          var slider = $('#ImageGal').lightSlider({
            gallery:true,
            item:1,
            vertical:true,
            verticalHeight:700,
            vThumbWidth:200,
            thumbItem:3,
            currentPagerPosition: 'left',
            thumbMargin:4,
            slideMargin:0,
            responsive : [
                {
                    breakpoint:1338,
                    settings: {
                        item:1,
                        slideMove:1,
                        verticalHeight:600,
                        vThumbWidth:100,
                      }
                },
                {
                    breakpoint:800,
                    settings: {
                        item:1,
                        slideMove:1,
                        verticalHeight:500,
                        vThumbWidth:150,
                      }
                },
                {
                    breakpoint:480,
                    settings: {
                        item:1,
                        slideMove:1,
                        verticalHeight:300,
                        vThumbWidth:60,
                        thumbItem:3,
                      }
                }
            ]
          }); 
    });

    axios.get(API_BASE_URL + 'portfolio/similar')
      .then(response => {this.random = response.data});


      //if (typeof slider !== 'undefined') {
      //    slider.destroy(); 
      //}

       
       //slider.destroy(); 

    

  },
  updated(){
     $(".parallax").inertiaScroll({  parent: $("#SiteWrapper")  });
     setTimeout(function() {
          $(this).trigger('resize');
      }, 100);

      


  },
  methods: {
    loaded:function (e) {
        $(this).trigger('resize');
        console.log('rs');
      }
  }
}

</script>
<style>
@import './../assets/css/easyResponsiveTabs.css';
@import './../assets/css/lightslider.css';
</style>


// WEBPACK FOOTER //
// src/views/PortfolioDetailed.vue